<div *ngIf="!_hidden" class="link-preview">
    <div *ngIf="!openGraphData; else preview">
        <i class="fa fa-spinner fa-spin link-preview-spinner"></i>
        <div class="link-preview-content">Đang tải chế độ xem trước...</div>
    </div>
    <ng-template #preview>
        <div *ngIf="openGraphData?.imageInfo?.available"
             [ngClass]="openGraphData?.imageInfo?.landscape ? 'landscape mb-0' : 'portrait mb-0'"
             class="link-preview-image">
            <img [src]="openGraphData?.image">
        </div>
        <div class="link-preview-content bg-white">
            <div class="link-preview-title">{{openGraphData?.title}}</div>
            <div class="link-preview-text">{{openGraphData?.description}}</div>
            <div class="link-preview-url">{{getDomain(openGraphData?.url)}}</div>
        </div>
        <a [href]="openGraphData?.url" target="_blank" rel="noopener nofollow" class="link-preview-anchor"></a>
    </ng-template>
    <i *ngIf="removable" (click)="removePreView()" class="fa fa-times link-preview-remove"></i>
</div>
